import { ChatButtonTypes } from '@shared/types'

interface ButtonData {
  id: string
  call_country?: string | null
  call_phone?: string | null
  website_url?: string | null
}

export const shouldDisableButton = (
  buttonType: string,
  isLastChunk: boolean,
  isSending: boolean,
): boolean => {
  if (buttonType === ChatButtonTypes.REPLY) {
    return !isLastChunk || isSending
  }
  return isSending
}

export const handleChatButtonClick = (
  buttonText: string,
  buttonType: string,
  buttonId: string,
  buttons: ButtonData[],
  sendMessage: (text: string) => void,
  isSending: boolean,
) => {
  switch (buttonType) {
    case 'reply':
      if (!isSending) {
        sendMessage(buttonText)
      }
      break
    case 'call': {
      const button = buttons.find((b) => b.id === buttonId)
      if (button?.call_phone) {
        const phoneNumber = `${button?.call_country || ''}${button?.call_phone || ''}`
        window.open(`tel:${phoneNumber}`, '_system')
      }
      break
    }
    case 'website': {
      const button = buttons.find((b) => b.id === buttonId)
      if (button?.website_url) {
        const url = button.website_url.startsWith('https://')
          ? button.website_url
          : `https://${button.website_url}`
        window.open(url, '_blank')
      }
      break
    }
    default:
      break
  }
}
